import { Pressable, View } from 'react-native'

import { styled } from '~/utils/styled'

export const Root = styled(Pressable, theme => {
  return {
    base: {
      width: '100%',
      borderRadius: theme.borderRadiusPill,
    },
    variants: {},
  }
})

export const Actions = styled(View, theme => {
  return {
    base: {
      flexDirection: 'row',
      alignItems: 'center',
      borderRadius: theme.borderRadiusPill,
      backgroundColor: 'transparent',
      minWidth: theme.sizingHuge,
      minHeight: theme.sizingSmall,
    },
    variants: {
      size: {
        md: {
          paddingTop: theme.paddingInsetTwopulse,
          paddingLeft: theme.paddingInsetTwopulse,
          paddingBottom: theme.paddingInsetTwopulse,
          paddingRight: theme.paddingInsetTwopulse,
          minWidth: theme.sizingMedium,
          minHeight: theme.sizingMedium,
        },
        ml: {
          paddingTop: theme.paddingInsetTwopulse,
          paddingLeft: theme.paddingInsetTwopulse,
          paddingBottom: theme.paddingInsetTwopulse,
          paddingRight: theme.paddingInsetTwopulse,
          minWidth: theme.sizingMediumlarge,
          minHeight: theme.sizingMediumlarge,
        },
        lg: {
          paddingTop: theme.paddingInsetTwopulse,
          paddingLeft: theme.paddingInsetTwopulse,
          paddingBottom: theme.paddingInsetTwopulse,
          paddingRight: theme.paddingInsetTwopulse,
          minWidth: theme.sizingLarge,
          minHeight: theme.sizingLarge,
        },
        xl: {
          paddingTop: theme.paddingInsetThreepulse,
          paddingLeft: theme.paddingInsetThreepulse,
          paddingBottom: theme.paddingInsetThreepulse,
          paddingRight: theme.paddingInsetThreepulse,
          minWidth: theme.sizingExtralarge,
          minHeight: theme.sizingExtralarge,
        },
      },
      hasPressed: {
        true: {
          backgroundColor: theme.colorActionFillNeutralTertiaryPressed,
          borderColor: theme.colorActionBorderNeutralTertiaryPressed,
          borderWidth: theme.borderWidthNone,
        },
      },
      hasError: {
        true: {
          borderWidth: theme.borderWidthHalfpulse,
          borderColor: theme.colorFormsBorderError,
        },
      },
      hasDisabled: {
        true: {
          backgroundColor: theme.colorActionFillNeutralTertiaryDisabled,
          borderColor: theme.colorActionBorderNeutralTertiaryDisabled,
          borderWidth: theme.borderWidthNone,
        },
      },
      hasReadOnly: {
        true: {
          //@TODO trocar para o token theme.colorActionFillNeutralTertiaryReadonly
          backgroundColor: '#00000000',
          //@TODO trocar para o token theme.colorActionBorderNeutralTertiaryReadonly
          borderColor: '#00000000',
          borderWidth: theme.borderWidthNone,
        },
      },
    },
    compoundVariants: [
      {
        variants: {
          size: 'xl',
          hasInternalLabel: true,
        },
        css: {
          paddingLeft: theme.paddingInsetSixpulse,
          paddingRight: theme.paddingInsetSixpulse,
        },
      },
      {
        variants: {
          size: 'lg',
          hasInternalLabel: true,
        },
        css: {
          paddingLeft: theme.paddingInsetFivepulse,
          paddingRight: theme.paddingInsetFivepulse,
        },
      },
      {
        variants: {
          size: 'ml',
          hasInternalLabel: true,
        },
        css: {
          paddingLeft: theme.paddingInsetFourpulse,
          paddingRight: theme.paddingInsetFourpulse,
        },
      },
      {
        variants: {
          size: 'md',
          hasInternalLabel: true,
        },
        css: {
          paddingLeft: theme.paddingInsetFourpulse,
          paddingRight: theme.paddingInsetFourpulse,
          paddingTop: theme.paddingInsetOnepulse,
          paddingBottom: theme.paddingInsetOnepulse,
        },
      },
    ],
  }
})

export const HelperTextContainer = styled(View, theme => {
  return {
    base: {
      alignItems: 'center',
      width: '100%',
      paddingTop: theme.spacingStackTwopulse,
      backgroundColor: 'transparent',
      paddingLeft: theme.paddingInsetSixpulse,
      paddingRight: theme.paddingInsetSixpulse,
    },
    variants: {
      size: {
        md: {
          paddingLeft: theme.paddingInsetFourpulse,
          paddingRight: theme.paddingInsetFourpulse,
        },
        ml: {
          paddingLeft: theme.paddingInsetFourpulse,
          paddingRight: theme.paddingInsetFourpulse,
        },
        lg: {
          paddingLeft: theme.paddingInsetFivepulse,
          paddingRight: theme.paddingInsetFivepulse,
        },
        xl: {
          paddingLeft: theme.paddingInsetSixpulse,
          paddingRight: theme.paddingInsetSixpulse,
        },
      },
    },
  }
})

export const NestedContainer = styled(View, theme => {
  return {
    base: {
      paddingTop: theme.paddingInsetOnepulse,
      paddingLeft: theme.paddingInsetEightpulse,
    },
    variants: {},
  }
})
